import React from 'react'
import styled from 'styled-components'

import theme from '../../../theme'
import Media from '../../../utils/Media'
import { Container } from '../../shared/Container'
import Layout from '../../shared/Layout'
import PageHeader from '../../shared/PageHeader'

const SecurityTemplate: React.FC = () => (
  <Layout>
    <PageHeader
      label="情報セキュリティ方針"
      backgroundImage="/images/picture/privacy_hero.jpg"
    />

    <Container size="large">
      <SecurityBody>
        <h2>基本理念</h2>
        <p>
          RYDE株式会社（以下、当社）は、「世のため、人の移動のため。」を理念とし、事業を行っています。
          <br />
          当社の事業の中で取り扱う、お客様の情報をはじめとする情報資産は、当社の経営基盤として極めて重要なものです。
          <br />
          漏洩、き損、滅失等のリスクから、情報資産を保護することの重要性を認識した役員や従業員を含めた、情報資産を扱う者が本方針を遵守し、情報資産の機密性、完全性、可用性といった情報セキュリティを維持するための活動を実践します。
        </p>

        <h2>基本方針</h2>
        <ol>
          <li>
            情報資産を保護するために、情報セキュリティ方針ならびに、それにまつわる規程類を策定し、これに従って業務を行うとともに、情報セキュリティに関連する法令、規制その他の規範、及び、お客様との契約事項を遵守いたします。
          </li>
          <li>
            情報資産に対して存在する漏洩、き損、滅失等のリスクを分析、評価するための基準を明確にし、体系的なリスクアセスメント方法を確立するとともに、定期的にリスクアセスメントを実施いたします。また、その結果に基づき、必要かつ適切なセキュリティ対策を実施いたします。
          </li>
          <li>
            担当役員を中心とした情報セキュリティ体制を確立するとともに、情報セキュリティに関する権限および責任を明確にいたします。また、すべての従業者が、情報セキュリティの重要性を認識し、情報資産の適切な取り扱いを確実にするために、定期的に教育、訓練および啓発を行います。
          </li>
          <li>
            情報セキュリティポリシーの遵守状況及び情報資産の取扱いについて、定期的に点検及び監査を行い、発見された不備や改善項目については、速やかに是正処置を講じます。
          </li>
          <li>
            情報セキュリティ上のイベントやインシデントの発生に対する適切な処置を講じるとともに、万一それらが発生した場合に際して、あらかじめ、被害を最小限に留めるための対応手順を確立し、有事の際には、速やかに対応するとともに、適切な是正処置を講じます。また、特に、業務中断に関わるようなインシデントについては、その管理の枠組みを確立し、定期的に見直しを行うことにより、当社の事業継続を確実にいたします。
          </li>
          <li>
            基本理念を実現するための目標を定めた情報セキュリティマネジメントシステムを確立し、これを実行するとともに、継続的に見直し、改善を行います。
          </li>
        </ol>
        <p className="signature">
          2024年8月1日 制定
          <br />
          RYDE株式会社
          <br />
          代表取締役 杉﨑 正哉
        </p>
      </SecurityBody>
    </Container>
  </Layout>
)

// PrivacyTemplateを元に作成
const SecurityBody = styled.div`
  padding-bottom: 54px;
  word-break: break-word;

  ${theme.typography.DefNotoSansBody}

  p.signature {
    text-align: right;
  }

  * + p {
    margin-top: 2em;
  }

  p {
    b {
      font-weight: 700;
    }

    a {
      color: ${theme.colors.textLink};

      &:hover {
        color: #000;
      }
    }
  }

  h2 {
    ${theme.typography.DefNotoSans4}
  }
  h2:not(:first-child) {
    margin-top: 60px;
    margin-bottom: 30px;
  }

  li {
    position: relative;
  }

  ol {
    margin-top: 2em;
    padding-left: 34px;

    li {
      counter-increment: cnt;
    }
  }
  ol li::before {
    content: '(' counter(cnt) ') ';
    position: absolute;
    top: 0;
    left: -34px;
  }

  ul {
    padding-left: 29px;

    li {
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 15px;
        left: -13px;
        width: 3px;
        height: 3px;
        border-radius: 50% 50%;
        background-color: #000;
      }
    }
  }

  * + table {
    margin-top: 64px;
  }

  table {
    border: solid 1px black;

    tr {
      border-bottom: solid 1px black;
    }
    th {
      padding: 12px 18px;
      border-right: solid 1px black;
      font-weight: 700;
      line-height: 1.5;
      vertical-align: middle;
    }
    td {
      padding: 12px 18px;
      border-right: solid 1px black;
    }

    ${Media.mobileMiddle} {
      td {
        padding: 6px 10px;
      }
    }
    ${Media.mobile} {
      border: none;

      tr {
        display: block;
        border: 1px solid #000;
      }

      td {
        display: flex;
        padding: 6px 19px;
      }
      td:first-child {
        align-items: center;
        width: 100%;
        min-height: 80px;
        border-right: none;
        border-bottom: solid 1px black;
      }
      td:last-child {
        width: 100%;
      }

      tr + tr {
        margin-top: 10px;
      }
    }
  }
`

export default SecurityTemplate
